import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "refetch"];
import { useMemo } from 'react';
import { useGetAiAgentsForPortalQuery } from '../../../__generated__/chirp/com/hubspot/cv/ai/agents/configuration/rpc/AiAgentService.hooks';
const getHasConfiguredAgent = agents => {
  return agents.some(agent => !(agent !== null && agent !== void 0 && agent.isPreview));
};
export const useHasConfiguredCustomerAgent = () => {
  const _useGetAiAgentsForPor = useGetAiAgentsForPortalQuery({
      onCompleted: response => {
        var _response$result, _response$result2;
        const hasConfiguredAgent = response !== null && response !== void 0 && response.result ? getHasConfiguredAgent(response === null || response === void 0 || (_response$result = response.result) === null || _response$result === void 0 ? void 0 : _response$result.results) : undefined;
        if (response !== null && response !== void 0 && (_response$result2 = response.result) !== null && _response$result2 !== void 0 && _response$result2.hasMore && !hasConfiguredAgent) {
          void refetch({
            offset: response.result.offset
          });
        }
      }
    }),
    {
      data,
      refetch
    } = _useGetAiAgentsForPor,
    rest = _objectWithoutPropertiesLoose(_useGetAiAgentsForPor, _excluded);
  const hasConfiguredAgent = useMemo(() => {
    return data ? getHasConfiguredAgent(data.results) : undefined;
  }, [data]);
  return Object.assign({
    hasConfiguredAgent,
    refetch
  }, rest);
};